import { render, staticRenderFns } from "./RepositoryView.vue?vue&type=template&id=0de0ba45&scoped=true&"
import script from "./RepositoryView.vue?vue&type=script&lang=js&"
export * from "./RepositoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de0ba45",
  null
  
)

export default component.exports